<script setup>
import {computed} from "vue";
import {useGetData} from "@/components/common/Composables/useGetData";
import DataGrid from "@/components/DataGrid/DataGrid.vue";
import {formatDateTime} from "@/utils/filters";
import store from "@/store";


const props = defineProps({
    peerId: {
        type: Number,
        required: false
    }
})
const currency = computed(() => store.getters.currency)

const getData = useGetData('getNodeActivities', {
    currency: currency.value.unit,
    peerId: props.peerId,
}, false)

const headers = [
    {text: 'Start of activity', align: 'center', value: 'activity_start'},
    {text: 'End of activity', align: 'center', value: 'activity_end'},
    {text: 'User Agent', align: 'center', value: 'user_agent'},
    {text: 'Protocol Version', align: 'center', value: 'protocol_version'},
    {text: 'Services', align: 'center', value: 'services'},
]

const nodeActivityEndDate = (activityEndTimestamp) => activityEndTimestamp === null ? "Ongoing" : formatDateTime(activityEndTimestamp)

</script>

<template>
    <v-card class="mt-2" outlined>
        <DataGrid
            :bulkOperations="false"
            :getData="getData"
            :headers="headers"
            :itemsPerPage="10"
            computed-height
            itemid="id"
            sort-desc
        >
            <template #item="{ item }">
                <td>
                    <span>{{ item.activity_start | formatDateTime }}</span>
                </td>
                <td>
                    <span>{{ nodeActivityEndDate(item.activity_end) }}</span>
                </td>
                <td>
                    <span>{{ item.service.user_agent }}</span>
                </td>
                <td>
                    <span>{{ item.service.protocol_version }}</span>
                </td>
                <td>
                    <span>{{ item.service.services }}</span>
                </td>
            </template>
        </DataGrid>
    </v-card>
</template>

<style scoped>

</style>